﻿import { $$ } from "@/Utils";
import { tns, TinySliderSettings } from "tiny-slider/src/tiny-slider"

export function initCarousels() {
  $$("[data-carousel]").forEach((carouselContainer: HTMLElement) => {

    if (carouselContainer.getAttribute("data-bound")) {
      return;
    }
    carouselContainer.setAttribute("data-bound", "true");

    const carouselControls = carouselContainer.querySelector("[data-carousel-controls]");
    const carouselElements = carouselContainer.querySelector("[data-carousel-elements]");
    if (!carouselControls || !carouselElements) return;
    const isVideo = carouselContainer.getAttribute("data-carousel") === "videos";
    let maxVisibleCount = parseInt(carouselContainer.getAttribute("data-max-visible-count"));

    maxVisibleCount = isVideo
      ? 1
      : maxVisibleCount > 0
        ? maxVisibleCount
              : 5;

    const slider = tns(({
      container: carouselElements,
      items: maxVisibleCount,
      slideBy: maxVisibleCount,
      controls: true,
      autoplay: false,
      navPosition: "bottom",
      controlsContainer: carouselControls,
        disable: true,
        responsive: {
            1216: {
                disable: false
            }
        },
      useLocalStorage: false,
      preventScrollOnTouch: "auto",
    }) as TinySliderSettings);
    
    const info = slider.getInfo();

    if (info.slideCount <= maxVisibleCount) {
      info.container.classList.add("items-carousel__bottom");
    }
  });
}